export class CampaignService {
  constructor($http) {
    this.http = $http;
  }

  getCampaigns() {
    return this.http.get('/api/campaign');
  }

  createCampaign(campaign) {
    return this.http.post('/api/campaign', campaign);
  }

  updateCampaign(campaign) {
    return this.http.put('/api/campaign/' + campaign._id, campaign);
  }

  removeCampaign(campaign) {
    return this.http.delete('/api/campaign/' + campaign);
  }
}
